/* =========================================================
   Life InStyle — sticky add-to-cart bar on phones.
   sections/instyle-product.liquid

   The bar's button is a second submit button for Dawn's own product form
   (form="product-form-<section>"), so adding to the cart still goes through
   product-form.js unchanged. This file only decides when the bar shows and
   keeps it truthful:

   - shown once the main Add to cart has scrolled ABOVE the screen; a button
     that is merely below the fold on arrival does not count;
   - phones only (max-width: 749px), matching the CSS;
   - its disabled / sold-out / loading state and its price are copied from
     the main button and the main price, which product-info.js updates when
     a size is chosen. The bar never decides any of that itself. Only the
     current price is copied (not a struck-through compare-at price), and it
     is hidden whenever Dawn hides the main price for a combination that does
     not exist;
   - while the bar is up, <body> carries `instyle-pdp-bar-up`, which reserves
     room under the footer; on a short page where the bar never appears no
     room is reserved;
   - an add-to-cart error is written by Dawn next to the MAIN button, which is
     above the screen when the bar is in use, so it is scrolled into view;
   - never in Dawn's quick-add modal, which has its own button in view.
   ========================================================= */
(function () {
  if (window.InStylePdpSticky) {
    window.InStylePdpSticky.initAll();
    return;
  }

  function initBar(root) {
    var bar = root.querySelector('[data-pdp-bar]');
    if (!bar || bar.dataset.pdpReady) return;
    bar.dataset.pdpReady = '1';
    if (root.closest('quick-add-modal') || root.dataset.originalSection) return;

    var sectionId = root.dataset.section;
    var button = bar.querySelector('[data-pdp-bar-button]');
    var priceOut = bar.querySelector('[data-pdp-bar-price]');
    var target =
      root.querySelector('[data-pdp-buy] .product-form__buttons') || root.querySelector('[data-pdp-buy]');
    if (!target || !button) return;

    var phone = window.matchMedia('(max-width: 749px)');
    var past = false;
    var shown = false;

    function render() {
      var on = phone.matches && past && bar.isConnected;
      shown = on;
      bar.classList.toggle('is-shown', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('instyle-pdp-bar-up', on);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
        render();
      }).observe(target);
    }
    if (phone.addEventListener) phone.addEventListener('change', render);
    else if (phone.addListener) phone.addListener(render);

    function mainButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function mirrorButton() {
      var main = mainButton();
      if (!main) return;
      button.disabled = main.disabled;
      if (main.getAttribute('aria-disabled') === 'true') button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
      var loading = main.classList.contains('loading');
      button.classList.toggle('loading', loading);
      var spin = button.querySelector('.loading__spinner');
      if (spin) spin.classList.toggle('hidden', !loading);
      var from = main.querySelector('span');
      var to = button.querySelector('span');
      if (from && to) {
        var text = from.textContent.trim();
        if (text && to.textContent.trim() !== text) to.textContent = text;
      }
    }

    function mirrorPrice() {
      var price = document.getElementById('price-' + sectionId);
      if (!price || !priceOut) return;
      var value = price.querySelector('[data-pdp-price-value]');
      var text = (value || price).textContent.trim();
      if (text && priceOut.textContent.trim() !== text) priceOut.textContent = text;
      var row = price.querySelector('.instyle-pdp__price-row');
      priceOut.classList.toggle('is-sale', !!(row && row.classList.contains('is-sale')));
      bar.classList.toggle('is-unpriced', price.classList.contains('hidden'));
    }

    function revealError() {
      var wrap = root.querySelector('.product-form__error-message-wrapper');
      if (!wrap || wrap.hidden || !shown) return;
      wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    if ('MutationObserver' in window) {
      var main = mainButton();
      if (main) {
        new MutationObserver(mirrorButton).observe(main, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
      var price = document.getElementById('price-' + sectionId);
      if (price) {
        new MutationObserver(mirrorPrice).observe(price, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
      var errorWrap = root.querySelector('.product-form__error-message-wrapper');
      if (errorWrap) {
        new MutationObserver(revealError).observe(errorWrap, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    mirrorButton();
    mirrorPrice();
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-instyle-pdp]').forEach(initBar);
  }

  window.InStylePdpSticky = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  // Theme editor: a removed section must not leave the footer room behind.
  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('instyle-pdp-bar-up');
  });
})();
